export const PLANS = [
  {
    id: 'open_source',
    name: 'Open Source',
    price: 0,
    currency: 'USD',
    interval: 'month',
    limits: {
      analyses: 30,
      videoVerifications: 10,
    },
    features: [
      'Zibby CLI runner',
      'Playwright script generation',
      'Unlimited local test execution',
      'Bring your own AI tokens',
    ],
    stripePriceId: null,
    popular: false,
    hint: 'Free forever',
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 49,
    currency: 'USD',
    interval: 'month',
    limits: {
      analyses: 200,
      videoVerifications: 100,
    },
    features: [
      'Everything in Open Source',
      '200 cloud analyses per month',
      '100 video verifications per month',
      'Jira / GitLab / GitHub integrations',
      'Email support',
    ],
    stripePriceId: process.env.REACT_APP_STRIPE_PRO_PRICE_ID,
    popular: true,
    hint: 'Best for teams',
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: null,
    currency: 'USD',
    interval: 'month',
    limits: {
      analyses: 800,
      videoVerifications: 400,
    },
    features: [
      'Everything in Pro',
      '800 cloud analyses per month',
      '400 video verifications per month',
      'Custom integrations',
      'Priority support',
    ],
    stripePriceId: null,
    popular: false,
    hint: 'Contact us',
  },
];

export const getPlanById = (planId) => {
  return PLANS.find(plan => plan.id === planId);
};

export const getPlanByStripeId = (stripePriceId) => {
  return PLANS.find(plan => plan.stripePriceId === stripePriceId);
};

export const formatPrice = (price, currency = 'USD') => {
  if (price === null || price === undefined) return 'Custom';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(price);
};

export const formatTokens = (tokens) => {
  if (tokens >= 1000000) {
    return `${(tokens / 1000000).toFixed(1)}M`;
  } else if (tokens >= 1000) {
    return `${(tokens / 1000).toFixed(0)}K`;
  }
  return tokens.toString();
};
